import BeautyIndex from "../../pages/Dashboard/Beauty/BeautyIndex";
import BeautyNav from "../../pages/Dashboard/Beauty/BeautyNav";
import AddProcedure from "../../pages/Dashboard/Beauty/Procedure/AddProcedure";
import BeautyDashboard from "../../pages/Dashboard/Beauty/Procedure/BeautyDashboard";
import ProcedureList from "../../pages/Dashboard/Beauty/Procedure/ProcedureList";
import ProcedureType from "../../pages/Dashboard/Beauty/Procedure/ProcedureType";
import NewPatient from "../../pages/Dashboard/Reception/NewPatient/NewPatient";

const BeautyRoutes = {
  path: "/beauty",
  element: <BeautyNav />,
  children: [
    { path: "", element: <BeautyDashboard /> },
    { path: "/beauty/new-patient", element: <NewPatient /> },
    { path: "/beauty/add-procedure", element: <AddProcedure /> },
    { path: "/beauty/view-procedure", element: <ProcedureList /> },
    { path: "/beauty/type", element: <ProcedureType /> },
  ],
};

export default BeautyRoutes;
